import { AppDeleteButton } from "../../components/AppDeleteButton";
import {
  EditContextProvider,
  SaveButton,
  SimpleForm,
  TextInput,
  Title,
  useEditController,
} from "react-admin";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";

export const UserCategoryEdit = (props: any) => {
  const { id } = useParams();
  const controller = useEditController({
    resource: "user-categories/crud",
    mutationMode: "pessimistic",
    id,
  });
  return (
    <EditContextProvider value={controller}>
      <Title title="Categorias de Sócios" />
      {/* toolbar={false}: Salvar/Remover no topo, junto do Ver */}
      <SimpleForm toolbar={false}>
        <PageTopBreadcrumb
          title="Categoria de Sócios"
          firstPath="/#/user-categories/crud"
          secondTitle="Editando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="show"
          actions={
            <>
              <AppDeleteButton label="Remover" />
              <SaveButton label="Salvar" />
            </>
          }
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader
            title="Categoria de Sócios"
            // subheader="September 14, 2016"
          />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12}>
                <TextInput source="id" fullWidth disabled helperText={false} />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  source="name"
                  label="Nome"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
